import {Directive, Host, HostListener, Input} from '@angular/core';
import { DraggableComponent } from '../draggable.component';

@Directive({
  selector: '[appDragHandle]'
})
export class DragHandleDirective {

  constructor(@Host() private draggable: DraggableComponent) {
    draggable.hasHandle = true;
  }

  @Input('appDragHandleDisabled') disabled = false;

  @HostListener('mousedown')
  public enableDragging() {
    if (this.disabled) {
      return;
    }

    this.draggable.isDraggable = true;
  }

}
